import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { InputText } from 'primereact/inputtext'
import { classNames } from 'primereact/utils'

export const EmailInput: React.FC<{ loading: boolean }> = ({ loading }) => {
  const { control } = useFormContext()

  return (
    <div className='auth-input-field'>
      <label htmlFor='email' className='auth-form-label'>
        Email address
      </label>
      <Controller
        name='email'
        control={control}
        rules={{
          required: 'Email address is required.',
          pattern: {
            value: /\S+@\S+\.\S+/,
            message: 'Entered value does not match email format',
          },
        }}
        render={({ field, fieldState }) => (
          <>
            <InputText
              placeholder='Enter your email address'
              disabled={loading}
              className={classNames('auth-input', { 'auth-input-error': fieldState.error })}
              id={field.name}
              {...field}
            />
            {!!fieldState.error && <span className='p-error'>{fieldState.error.message}</span>}
          </>
        )}
      />
    </div>
  )
}
